import React, { Component } from 'react';
import PatientModel from "../../models/patient";
import  PanelLayout  from "../layout/panel-layout";

import BSelectInput from "../../helpers/bselect-input";
import SimpleReactValidator from 'simple-react-validator';

import BDateInput from '../../helpers/bdate-input'
import BCamInput from '../../helpers/bcam-input'
import moment from 'moment-jalaali';
import GeoLocation from "../partials/geolocation";

import { DatePicker } from 'react-persian-datepicker';
import data from './../../data/cities.json'

import 'react-persian-datepicker/lib/styles/basic.css';
import InputMask from 'react-input-mask';

import { enumNationalCodeStatus} from "../../constants/enum.constants";
import EnumRadioInput from "../../helpers/enumRadioInput";

import {
    Prompt
  } from "react-router-dom";

  
const styles = {
  calendarContainer: 'calendarContainer',
  heading: 'heading',
  prev: 'prev',
  next: 'next',
  title: 'title',
  dayWrapper: 'dayWrapper',
  currentMonth: 'currentMonth',
  daysOfWeek: 'daysOfWeek',
  monthsList: 'monthsList',
  selected: 'selected',
  dayPickerContainer: 'dayPickerContainer'
};


const GenderList = [
    { label: "مرد", value: 1 },
    { label: "زن", value: 2 },
    { label: "نامشخص", value: 3 }

  ];
  



class Patient extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           _model:new PatientModel(this.refs),
           cityList:null,
           isChanged:false,
           
          
        };
        let __model=this.state._model;
        __model.NationalCodeStatus=0;
        this.setState({_model:__model})
       // moment.loadPersian({usePersianDigits: false,dialect: 'persian'})
       // moment.defaultFormat ='DD-MM-YYYY HH:mm';
        this.updateCitySelect = this.updateCitySelect.bind(this);
        this.updateGenderSelect = this.updateGenderSelect.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.refreshModel = this.refreshModel.bind(this);
        this.refreshModelRadio = this.refreshModelRadio.bind(this);
        this.updateCam = this.updateCam.bind(this);
        this.handleCitySelectChange=this.handleCitySelectChange.bind(this);
        this.handleStepClick=this.handleStepClick.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
        this._handleKeyDown=this._handleKeyDown.bind(this);

        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

        this.validator = new SimpleReactValidator({
            locale: 'fa',
            validators: {
                iraniannationalcode: {  // name the rule
                message: 'کد ملی نامعتبر',
                rule: (val, params, validator) => {
                    return this.isValidIranianNationalCode(val)
                },
                messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                required: true  // optional
            }
          }});

    }

    isValidIranianNationalCode(input) {
        if (!/^\d{10}$/.test(input))
            return false;
     
        var check = +input[9];
        var sum = Array(9).fill().map((_, i) => +input[i] * (10 - i)).reduce((x, y) => x + y) % 11;
        return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
    }

    
    handleTextChange(event) {
        let name=event.target.name;
        let value=event.target.value;
        if(name == "NationalCode")
        {
            if(this.isValidIranianNationalCode(value))
            {
                let spcode= value.substring(0, 3);
                let spcity = data.filter(x=>x.Code.contains(spcode));
                if(spcity.length > 0)
                {
                    const {_model}= this.state;
                    _model.IdentityCityName= spcity[0].City;
                    console.log('aa',_model);

                    this.setState({_model: _model});

                    this.refs['IdentityCityName'].value=spcity[0].City;

                    this.forceUpdate();

                }
               
            }
        }
        this.refreshModel();
    }

    handleDateChange(event) {
      console.log(event);
      
     //   this.refreshModel();
    }

    handleCitySelectChange(item)
    {
        console.log('CITYSELECT',item)
        const{_model}=this.state;
        if(_model)
        {
            if(item)
            {
                _model.IdentityCityId=item.Id;
                this.setState({
                    _model:_model
                });
            }
        }

    }

    componentWillReceiveProps(newProps)
    {
        const {model,citylist}=newProps;
        if(model)
        {
            this.setState({

                _model:model,
               
    
            });
           

        }
       
        
       
    }

    componentDidUpdate = () => {
        if (this.state.isChanged) {
          window.onbeforeunload = () => true
        } else {
          window.onbeforeunload = undefined
        }
      }

      refreshModelRadio (value=null,event) {
        var name=event.target.name;
       // let _model = new CertMoralFormModel(this.refs);  

        let __model = new PatientModel(this.refs);  
        __model[name]=value;

        // __model.BirthDate = moment(__model.BirthDate);
         this.setState({
 
             _model:__model,
             isChanged:true
 
         });

        console.log('MODEL9',__model);    
    }

    refreshModel () {
        let __model = new PatientModel(this.refs);  
       // __model.BirthDate = moment(__model.BirthDate);
        this.setState({

            _model:__model,
            isChanged:true

        });

        console.log('MODEL',__model);    
    }
    getData() {
        let model = new PatientModel(this.refs);
        return model;
    }
    updateGenderSelect(item) {
        
        let __model = new PatientModel(this.refs);  
        console.log(__model);

        __model.Gender=item && item.value;
        

        this.setState({

            _model:__model

        });
       
    }
    updateCitySelect(item) {
        
        let __model = new PatientModel(this.refs);  
        

        __model.IdentityCityId=item.value;
        console.log(__model);

        this.setState({

            _model:__model

        });
       
    }

    updateCam(value) {
        console.log(value);
        let __model = new PatientModel(this.refs);  

        __model.PatientImg=value;
        

        this.setState({

            _model:__model

        });

    }



    handleClick = (e) => {
        if (this.validator.allValid()) {
            this.setState({
                isChanged:false
            })    
            this.props.submitHandler(e);
           
            
           
        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };
    handleStepClick = (e) => {
        if (this.validator.allValid()) {

            this.setState({
                isChanged:false
            }) 

            this.props.submitStepHandler(e);
           
        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    componentDidMount()
    {

        


        for (let x in this.refs) {
            
           // this.refs[x].onkeypress = (e) => 
            //  this._handleKeyPress(e, this.refs[x]);

            this.refs[x].onkeydown = (e) => 
                this._handleKeyDown(e, this.refs[x]);
              
          }
    }

    _handleKeyPress(e, field) {
        
        if (e.keyCode === 13) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1].focus();
            e.preventDefault();
        }
    }

    _handleKeyDown(e) {
        console.log(e.keyCode);
        if (e.keyCode === 13) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1].focus();
            e.preventDefault();
        }

        if (e.keyCode === 40) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1].focus();
            e.preventDefault();
        }
        if (e.keyCode === 38) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index - 1].focus();
            e.preventDefault();
        }
    }

    render() { 
        //const {model} = this.props;
        const {_model,cityList,isChanged}= this.state;
        const {loading,error} = this.props;
        const model=_model;    

        console.log('aaddddddddddddddddddd',model);

        return ( 

        <PanelLayout title={"مراجع"}>

           
            <div className="panel-body custom">
{/*
 
            <div className="panel panel-default">
               
                <div className="toolbox">
{ (model.Id ==null || model.Id ==  "") &&
                    <button type="button" disabled ={loading } className="btn btn-success btn-sm" onClick={this.handleStepClick} ><i className="fa fa-save"></i>   ثبت و ادامه
                    
                        { loading &&
                            <i className="fa fa-spinner fa-spin"></i>
                        }

                    </button>
}
                    
{model.Id  &&                 

                    <button type="button" disabled ={loading } className="btn btn-success btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ثبت اطلاعات
                    
                     { loading &&
                         <i className="fa fa-spinner fa-spin"></i>
                     }

                     </button>
}  
                
                </div>
            </div>
  */}                                    
                
            <div class="panel panel-default">
                <div class="panel-heading">اطلاعات هویتی</div>
                <div class="panel-body">

                    <form autoComplete="off" ref={c => { this.form = c }}>

                    <Prompt
                        when={isChanged}
                        message='اطلاعات وارد شده در فرم ذخیره نشده است، آیا تمایل به ترک فرم جاری را دارید؟'
                        
                    />

                        {error &&
                            <div class="alert alert-danger">
                               {error}
                            </div>
                        }
                        <div className="col-md-6">
                        { model.Id !="" &&
                       
                            <input className="form-control" ref="Id" value={model && model.Id } name="Id" type="hidden" />
                            
                        }
                        { model.ReceptionId!=null &&

                            <input className="form-control" ref="ReceptionId" value={model && model.ReceptionId } name="Id" type="hidden" />
                            
                        }

                       
                            <div className="form-group">
                                <label>
                                   وضعیت کد ملی   &nbsp;
                                </label>
                                <EnumRadioInput enumObj={enumNationalCodeStatus} value={model && model.NationalCodeStatus ? model && model.NationalCodeStatus: 0 }  name="NationalCodeStatus" ref="NationalCodeStatus" onChange={this.refreshModelRadio}></EnumRadioInput>
                                <input className="form-control" ref="NationalCodeStatus" value={model && model.NationalCodeStatus ? model && model.NationalCodeStatus: 0 } name="NationalCodeStatus" type="hidden" />
                        </div>     
                        
                        { model && model.NationalCodeStatus == 0 &&  
                                        <div className="form-group">
                                        <label>
                                        کد ملی
                                        </label>
                                        <input  className="form-control" onChange={this.handleTextChange} value={model && model.NationalCode } ref="NationalCode" name="NationalCode"  type="text" />
                                        {this.validator.message('nationalCode', _model.NationalCode, 'required|iraniannationalcode')}
                                    </div>
                                    }
                                     {model && model.NationalCodeStatus==1 &&  
                                        <div className="form-group">
                                        <label>
                                        کد اتباع
                                        </label>
                                        <input  className="form-control" onChange={this.handleTextChange} value={model && model.NationalCode } ref="NationalCode" name="NationalCode"  type="text" />
                                        {this.validator.message('nationalCode', _model.NationalCode, 'required')}
                                    </div>
                                    }
                                   
                           
                            <div className="form-group">
                                <label>
                                    نام
                                </label>
                                <input  lang="fa"  className="form-control" onChange={this.handleTextChange} value={model && model.FirstName } ref="FirstName"  name="FirstName"   type="text" />
                                {this.validator.message('firstName', _model.FirstName, 'required')}
                            </div>
                            <div className="form-group">
                                <label>
                                    نام خانوادگی
                                </label>
                                <input  lang="fa"  className="form-control" onChange={this.handleTextChange} value={model && model.LastName }  ref="LastName" name="LastName" type="text" />
                                {this.validator.message('lastName', _model.LastName, 'required')}
                            </div>
                            <div className="form-group">
                                <label>
                                    شماره شناسنامه
                                </label>
                                <input  className="form-control" onChange={this.handleTextChange} value={model && model.IdentityCode } ref="IdentityCode" name="IdentityCode" type="text" />
                                {this.validator.message('identityCode', _model.IdentityCode, 'required')}
                            </div>
                            <div className="form-group">
                                <label>
                                    نام پدر
                                </label>
                                <input  lang="fa"  className="form-control" onChange={this.handleTextChange} value={model && model.FatherName } ref="FatherName" name="FatherName" type="text" />
                                {this.validator.message('FatherName', _model.FatherName, 'required')}
                            </div>   
                            
                            <div className="form-group">
                                <label>
                                    محل صدور
                                </label>                              
                                
                                <input   lang="fa" className="form-control" onChange={this.handleTextChange} value={model && model.IdentityCityName } ref="IdentityCityName" name="IdentityCityName" type="text" />
                               
                                {this.validator.message('IdentityCityName', _model.IdentityCityName, 'required')}
                               
                                
                            </div>
                           
                            
                        
                        </div>
                        <div className="col-md-6">
                                                             
                          
                            <div className="form-group">
                                <label>
                                    تاریخ تولد
                                </label>
                            {/*  <DatePicker  ref="BirthDate" className="form-control" calendarStyles={styles} value={moment(model.BirthDate).isValid()?  moment(model.BirthDate):moment() } 
                                onChange={this.handleDateChange} ></DatePicker>*/}
                            
                            <InputMask  className="form-control" mask="9999/99/99" value={model && model.BirthDate} maskChar={null} ref="BirthDate"  name="BirthDate"  onChange={this.refreshModel} />

                            {this.validator.message('BirthDate', _model.BirthDate, 'required')}
                               
                            {/* 
                            <BDateInput
                                
                                className="form-control"
                                ref="BirthDate" 
                                
                                onChange={this.handleDateChange}
                               
                             />
                             */}
                            </div>
                            <div className="form-group">
                                <label>
                                    جنس
                                </label>
                                <BSelectInput 
                                    ref="Gender"                                   
                                    onChange={this.refreshModel}
                                    value ={model && GenderList.find(p=>p.value=== model.Gender) }
                                    options={GenderList}
                                    onChangeHandler={this.updateGenderSelect}
                                    clearable={false}
                                    name="Gender"
                                    normal={true}
                                />
                                {this.validator.message('Gender', _model.Gender, 'required|integer')}
                            </div>
                            <div className="form-group">
                                <label>
                                    شماره موبایل
                                </label>
                                <input className="form-control" onChange={this.handleTextChange} value={model && model.CellNumber } ref="CellNumber" name="CellNumber"  type="text" />
                            </div>
                            <div className="form-group">
                              
                                <label>
                                    تصویر
                                </label>
                                
                                    <BCamInput width={180} height={180} ref="PatientImg" onChange={this.updateCam} value={model && model.PatientImg} name="PatientImg"></BCamInput>
                                
                            </div>

                        

                        </div>
                        
                        
                       
                    </form>
                
              
               
           </div>
                   
                
                </div>

        
 
            <div className="panel panel-default">
               
                <div className="toolbox">
{ (model.Id ==null || model.Id ==  "") &&
                    <button type="button" disabled ={loading } className="btn btn-success btn-sm" onClick={this.handleStepClick} ><i className="fa fa-save"></i>   ثبت و ادامه
                    
                        { loading &&
                            <i className="fa fa-spinner fa-spin"></i>
                        }

                    </button>
}
                    
{model.Id  &&                 

                    <button type="button" disabled ={loading } className="btn btn-success btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ثبت اطلاعات
                    
                     { loading &&
                         <i className="fa fa-spinner fa-spin"></i>
                     }

                     </button>
}  
                
                </div>
            </div>
     

            </div>

        </PanelLayout>





        );
    }
}

 
export default Patient;